import React, { useState, useEffect } from "react";
import Layout from "../components/Layout";
import SidebarLayout from "../components/Sidebar";
import StoreDetailPage from "../components/StoreDetailPage";
import axios from "axios";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { useLocation } from "react-router-dom";

const Search = () => {
  const [rbts, setRbts] = useState<any[]>([]);
  const {state} = useLocation();

  const { countryCode, msisdn } = useSelector(
    (state: RootState) => state.phone
  );

  const { subType, planId } = useSelector(
    (state: RootState) => state.profile
  );


  const handleSearch = async () => {
    if (!state.searchText) return;
         const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/Content/SearchRBTs?msisdn=${
        countryCode + msisdn
      }&service=${process.env.REACT_APP_SERVICE}&interface=${process.env.REACT_APP_INTERFACES}&langId=${process.env.REACT_APP_LANGID}&searchType=RBT&searchText=${state?.searchText}&pageNo=-1&countryCode=${countryCode}&subType=${subType}&planId=${planId}&pageSize=-1`
    );

    setRbts(res?.data?.toneListOfCategory || []);
  };

  useEffect(() => {
    handleSearch();
  },[state.searchText])

  return (
    <Layout>
      <SidebarLayout>
          <StoreDetailPage tones={rbts} />
      </SidebarLayout>
    </Layout>
  );
};

export default Search;
